exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".participants-header[data-v-27b15b34] {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.5;\n  color: #001648;\n  background-color: #dee7e6;\n  padding: 8px 16px;\n  border-radius: 4px 4px 0 0;\n  margin-bottom: 0;\n}\n", ""]);

// exports
